<ion-header><app-custom-header (notify)="onNotify($event)"></app-custom-header></ion-header>
<ion-content [ngClass] = "{'searchOn': search}" scrollEvents="true" (ionScroll)='onContentScroll($event)'>
  <app-title *ngIf="!auth.isAuthenticated()"></app-title>
  <app-filter *ngIf="auth.isAuthenticated()"></app-filter>
  <ng-container *ngIf="(!showSpinner && articles &&  articles.length === 0)">
    <div class="no-items">Aucun résultat pour votre recherche, veuillez réessayer en modifiant votre sélection.</div>
  </ng-container>
  <!-- Cards river start -->
  <ng-container *ngFor="let article of articles; let i = index; trackBy: trackByFn;">
    <ng-container *ngIf="dateIndexes.indexOf(i) !== -1 && category !== 'podcast-lepq'  && category !== 'lecons-de-dessin-play'">
      <app-timeline-date [isHeader]="dateIndexes.indexOf(i) === 0 && (multiTenant.getDomainClass() === 'mquovideo' || multiTenant.getDomainClass() === 'actuvideo' || multiTenant.getDomainClass() === 'playbacpresse')"
        [category]="category" [date]="formatDatePublish(article.publish_on)" [themeClass]="themeClass"></app-timeline-date>
      <!--  PDF content start -->
      <ng-container *ngIf="auth.isAuthenticated() && showNewspaperPdf && !!auth.hasAccessToPdf()">
        <app-newspaper-pdf  *ngFor="let pdf of getNewspapersPdfByDate(article.publish_on)" class="pdf-container mb-5"
          [category]="category" [themeClass]="themeClass" [pdf]="pdf"></app-newspaper-pdf>
      </ng-container>
      <!--  PDF content start -->
    </ng-container>
    <!-- [hidden]="(article.article_type === 'pub' || article.article_type === 'livre-pub' || article.article_sponsored)" -->
    <app-card
      [articles]="this.articles"
      [article]=article
      [video]="this.video"
      [themeClass]="this.themeClass"
      [i]="i"
      [category]="category"
      (showOnePerWeek)= "onShowOnePerWeek($event)"
      (activatePopUp)= "onActivatePopup($event)">
    </app-card>
  </ng-container>
  <!-- Cards river end -->
  <!-- Search cards river start -->
  <ng-container *ngFor="let article of searchResults">
    <app-search-card
      [article]="article"
      (showOnePerWeek)= "onShowOnePerWeek($event)"
      (activatePopUp)= "onActivatePopup($event)">
    </app-search-card>
  </ng-container>
  <!-- Search cards river end -->
  <app-cookie-info></app-cookie-info>
  <app-one-per-week [show]="showOpenPerWeek" (notify)="onNotifyOnePerWeek($event)"></app-one-per-week>
  <ion-infinite-scroll (ionInfinite)="doInfinite($event)" #infiniteScroll>
    <ion-infinite-scroll-content></ion-infinite-scroll-content>
  </ion-infinite-scroll>
</ion-content>
<ion-footer>
  <app-bottom-menu [isActive]="isActivePage" [isFilter]="isTimelineFilter" (bottomNotify) = "onBottomMenuNotify($event)"></app-bottom-menu>
</ion-footer>
<app-pop-up [show] = "tempPopUp" [data] = "popup" (popUpNotify)="onNotifyPopUp($event)" #temppopup></app-pop-up>
<ion-spinner *ngIf="showSpinner" name="lines" color="primary"></ion-spinner>
